function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#231f20;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "NCCO");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  className: "cls-1",
  d: "M164.12,65.34,140.58,41.73A153.78,153.78,0,0,1,332.8,62.62l-23,22.85A121.43,121.43,0,0,0,164.12,65.34ZM321.49,244.73a125.2,125.2,0,0,1-97.79,47.93A121.43,121.43,0,0,1,118.61,110.3L95.31,86.44a153,153,0,0,0-25.49,84.74c0,84.86,69,153.89,153.88,153.89,47.86,0,90.34-21.2,120.07-57.62ZM77.63,46.65h0l209.5,209.5.17.17a108.31,108.31,0,0,0,21.9-21.13l1.22-1.58-.26-.26L89,12.15,77.51,0,65.71,11.8c-87.61,87.62-87.61,229.68,0,317.3l22.92-22.92A192,192,0,0,1,77.63,46.65ZM383,11.82h0L360.1,34.73a192,192,0,0,1,11,259.53L355,278.21a179.59,179.59,0,0,1-22.81,23l.25.25,27.75,27.75,11.46,11.23L383,329.11C470.61,241.49,470.61,99.44,383,11.82Z"
})));

var SvgNetcents = function SvgNetcents(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 448.71 340.44",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNetcents, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/netcents.751b3094.svg";
export { ForwardRef as ReactComponent };